export default {
  SET_API_KEY(state, payload) {
    state.apiKey = payload
  },
}
